import { Component, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable, Subscription } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CONFIG } from 'src/helper/app-config';
import { SKUModal } from 'src/modals/planogram';
import { PlanogramStateService } from 'src/services/planogram-state.service';
import { PlanogramService } from 'src/services/planogram.service';

@Component({
  selector: 'app-sku-replace-dialog',
  templateUrl: './sku-replace-dialog.component.html',
  styleUrls: ['./sku-replace-dialog.component.css']
})
export class SkuReplaceDialogComponent implements OnDestroy {

  CONFIG = CONFIG;

  sku_search_input = '';
  filter_sku_list: SKUModal[] = [];
  sku_list: SKUModal[] = [];
  sku_filter = 'all';

  sas='?'+environment.sas
 
  sku_list_observer: Observable<SKUModal[]> = this.planogramState.available_skus;
  sku_list_subscriber : Subscription;


  constructor(private apiService: PlanogramService, private dialogRef: MatDialogRef<SkuReplaceDialogComponent>, private planogramState: PlanogramStateService, private sanitizer: DomSanitizer) {
    this.sku_list_subscriber = this.sku_list_observer.subscribe(sku_list=>{
      this.sku_list = sku_list;
      this.filterSkus(this.sku_filter)
    })
   }

   filterSkus = (filter:string)=>{
    this.sku_filter = filter;
    
    // Set the list immediately with empty image URLs
    let filtered_list: SKUModal[] = [];
    if(filter === 'recommanded'){
      filtered_list = this.sku_list.filter(s=> s.picos === 0);
    }else if(filter === 'picos'){
      filtered_list = this.sku_list.filter(s=> s.picos === 1);
    }else{
      filtered_list = this.sku_list;
    }

    this.filter_sku_list = filtered_list.map((sku) => ({
      ...sku,
      image_url: ''
    }));

    // Fetch images asynchronously for each SKU
    filtered_list.forEach((sku, index) => {
      this.apiService.fetchImageFromBlob(sku.sku_img_link).subscribe((blob: Blob) => {
        const imageUrl = URL.createObjectURL(blob);
        const safeUrl = this.sanitizer.bypassSecurityTrustUrl(imageUrl);
        this.filter_sku_list[index].image_url = safeUrl;
      });
    });
  }

  ngOnDestroy(){
    this.sku_list_subscriber.unsubscribe();
  }

  selectSku(sku : any){
    this.dialogRef.close(sku)

  }

}
